import request from '../utils/request'
export default {
	/*-------------------------------------------------------------费用 start-----------------------------------------------------------  */
    //费用预算费用类型填报查询-姜飞
    checkCostType({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/common/chargeBudget/queryChargeTypeBudgetList`,
			data: params
		})
	},
	// 费用预算填报查询-姜飞
	checkCost({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/queryChargeBudget`,
			data: params
		})
	},
	// 费用预算填报保存-姜飞
	saveCost({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/saveChargeBudget`,
			data: params
		})
	},
	// 会议/活动费用填报查询-姜飞
	actCostCheck({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/queryMarketChargeBudget`,
			data: params
		})
	},
	// 会议/活动费用填报保存-姜飞
	actCostSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/saveMarketChargeBudget`,
			data: params
		})
	},
	// 水电汽费用查询
	waterCostCheck({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/queryWaterChargeBudget`,
			data: params
		})
	},
	// 水电汽费用保存
	waterCostSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/saveWaterChargeBudget`,
			data: params
		})
	},
	// 预算发布
	costPublish({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/publishChargeBudget`,
			data: params
		})
	},
	selectedProduct({ ...params }){
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/queryMarketChargeBudgetTargetCode`,
			data: params
		})
	},
	// 费用删除
	delDepart({ ...params }){
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/deleteChargeBudget`,
			data: params
		})
	},
	// 查询品类树列表
	fetchCategoryList({ ...params }) {
		return request({
			method: 'POST',
			url: `/mm/base/getCategoryList`,
			data: params
		})
	},
	// 查询费用项预算填报数据（采购新增费用项）
	fetchChargeItem({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/queryChargeItemBudget`,
			data: params
		})
	},
	/*-------------------------------------------------------------费用 end-----------------------------------------------------------  */
	/*-------------------------------------------------------------费用 v3.0 start----------------------------------------------------  */
	// V3.0 费用列表查看 - 陈德林
	chargeBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/chargeBudget/getChargeBudget`,
			data: params
		})
	},
	// V3.0 费查询已填报的费用类型 - 陈德林
    chargeType({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/common/chargeBudget/queryChargeType?configurationId=${params.configurationId}`,
			data: params
		})
	},
	/*-------------------------------------------------------------费用 v3.0 end----------------------------------------------------  */
}
